import { useTranslation } from 'react-i18next';
import { Skeleton } from 'components/ui/skeleton';
import { useCommonStore } from 'state/store/common/useCommonStore';
import { useGetAccount } from 'features/profile/hooks/use-account';
import { ROLES } from 'constant/roles';
import { SigningInCard } from './signing-in-card';
import { TwoFactorCard } from './two-factor-card';
// Hidden for now; restore with the card below.
// import { SignedInDevicesCard } from './signed-in-devices-card';

// externalIdentities has no fixed shape in the API types, so look for "google" anywhere in an entry.
const hasGoogleIdentity = (identities: unknown[] = []) =>
  identities.some((identity) =>
    JSON.stringify(identity ?? '')
      .toLowerCase()
      .includes('google')
  );

/** Security tab (Figma 10596:1445) on the same account, MFA and session APIs as the Settings dialog. */
export function AccountSecurityTab() {
  const { t } = useTranslation();
  const user = useCommonStore((state) => state.user);
  const { data: account, isLoading, isError } = useGetAccount({ enabled: true });

  if (isLoading) {
    return (
      <div data-testid="account-security-loading" className="flex flex-col gap-4">
        <Skeleton className="h-36 w-full rounded-section" />
        <Skeleton className="h-48 w-full rounded-section" />
        <Skeleton className="h-48 w-full rounded-section" />
      </div>
    );
  }

  if (isError || !account) {
    return (
      <p className="py-6 text-sm text-grey-500 dark:text-muted-foreground">
        {t('SOMETHING_WENT_WRONG')}
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <SigningInCard isGoogleLinked={hasGoogleIdentity(account.externalIdentities)} />
      <TwoFactorCard account={account} isAdmin={Boolean(user?.roles?.includes(ROLES.ADMIN))} />
      {/* Signed-in devices card hidden for now. */}
      {/* <SignedInDevicesCard /> */}
    </div>
  );
}
